module.exports = "https://coursera_assets.s3.amazonaws.com/images/4855ef6f2cb6137776e476484b95456e.svg";